import React, { useContext, useState, useCallback, useEffect } from 'react';
import axios, { AxiosResponse } from 'axios';
import { useDropzone } from 'react-dropzone';
import { Icon, Header, Progress, Modal } from 'semantic-ui-react';
import TechnicianProjectStore from '../../stores/technicianprojectStore';
import { IPhoto } from '../../models/photo';
import { runInAction } from 'mobx';
import { toast } from 'react-toastify';
import LoadingComponent from '../../layout/LoadingComponent';

interface IProps {
  name: string;
  category: string;
}

const dropzoneStyles = {
  // border: 'dashed 3px',
  // borderColor: '#eee',
  // borderRadius: '5px',
  // paddingTop: '30px',
  textAlign: 'center' as 'center',
  // height: '50px'
};

const dropzoneActive = {

  borderColor: 'green'
};



const PhotoDropzone: React.FC<IProps> = ({ name, category }) => {
  const technicianprojectStore = useContext(TechnicianProjectStore);
  const {updateCount} = technicianprojectStore;
 const [progress, setProgress] = useState(0)
 const [uploading, setUploading] = useState(false)

  const uploadPhoto = async (photo : File[], name : string, category : string) => {
    if (typeof photo !== 'undefined' && photo.length > 0) 
    {   
      setUploading(true);
    try {
      // var photos : File[] = [];
      // photos.push(photo);
      // const photoreturn = await agent.Uploads.uploadPhoto(photo, name, category);
      axios.defaults.baseURL = process.env.REACT_APP_API_URL;
      let formData = new FormData();
      const responseBody = (response: AxiosResponse) => response.data;
      const Uploads = {
        uploadPhoto: (): Promise<IPhoto> =>
        axios
        .post('/photos', formData, {
          headers: { 'Content-type': 'multipart/form-data' }
        , onUploadProgress: function(progressEvent) {
           setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        },})
        .then(responseBody),
      }
      for (let i = 0; i < photo.length; i++) {
      formData.append('File', photo[i]);
      }
      formData.append('Name', name);
      formData.append('PhotoCategory', category);
      const photoreturn = await Uploads.uploadPhoto();

      runInAction(() => {
    updateCount(photoreturn, name);
    setUploading(false);
       toast.success('Photo uploaded successfully!');
      });
    } catch (error) {
      toast.error('Problem uploading photo');
      runInAction(() => {
        setUploading(false);
      });
    }
  }
  };

  const onDrop = useCallback(acceptedFiles => {
    uploadPhoto(acceptedFiles, name, category).then(()=> acceptedFiles.length = 0);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  // const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone();
  // const files = acceptedFiles.map(file => {
  //   var count = acceptedFiles.length;
  //   uploadPhoto(file, photoInfo, count);
  //   return <li key={file.name}>
  //   {file.name} - {file.size} bytes
  // </li>
  // });

 // uploadPhoto(acceptedFiles, photoInfo).then(()=> acceptedFiles.length = 0);
// if (loading) return <Progress percent={progress}/>
  return (
    <section>
      <div
        {...getRootProps()}
        style={
          isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
        }
      >
        <input {...getInputProps()} />
        {/* <Icon name='upload' size='big' /> */}
        Upload
        {/* <Header content='Click here' /> */}

      </div>
      {/* <ul>{files}</ul> */}
      <Modal
        open={uploading}
        style={{
          position: "relative",
          height: 'auto',
          textAlign: 'center',
        }}
      >
        <Modal.Content>
        {<Progress percent={progress} progress color='blue' size='small'/> }
        Uploading Photos
        </Modal.Content>
        </Modal>
      

    </section>
  );
};

export default PhotoDropzone;
